export default __webpack_public_path__ + "static/media/LO06.050f98b0.mp3";